import { render, staticRenderFns } from "./Outstanding.component.vue?vue&type=template&id=1da4d93e&"
import script from "./Outstanding.component.vue?vue&type=script&lang=ts&"
export * from "./Outstanding.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports